export default __webpack_public_path__ + "static/media/LOA_Vanquis.5e12d209.pdf";